// @flow
import React from "react";
import Button from "@material-ui/core/Button";
import LoaderAbsolute from "./LoaderAbsolute";

// see IEType.java
export const ExportTypes = {
  CSV: "CSV",
  TSV: "TSV",
  TAB: "TAB",
  TXT: "TXT",
  EXCEL: "EXCEL",
  // JSON: "JSON"
};

type Props = {
  onClick: Function,
  loading: boolean,
};

const Export = ({ onClick, loading }: Props) => {
  return (
    <div>
      <div>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.CSV)}
        >
          {ExportTypes.CSV}
        </Button>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.TSV)}
        >
          {ExportTypes.TSV}
        </Button>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.TAB)}
        >
          {ExportTypes.TAB}
        </Button>
      </div>
      <div>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.TXT)}
        >
          {ExportTypes.TXT}
        </Button>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.EXCEL)}
        >
          {ExportTypes.EXCEL}
        </Button>
        <Button
          color="secondary"
          disabled={loading}
          onClick={onClick(ExportTypes.JSON)}
        >
          {ExportTypes.JSON}
        </Button>
      </div>
      {loading && <LoaderAbsolute />}
    </div>
  );
};

export default Export;
